import { getCurrentInstance } from "vue";
function useToast() {
  const { proxy } = getCurrentInstance();
  if (!proxy.$toast) {
    throw new Error(
      "FhToastPlugin is not available. Make sure it's installed."
    );
  }
  return proxy.$toast;
}
export {
  useToast as default
};
//# sourceMappingURL=useToast.mjs.map
